<template>
    <v-sheet width="100vw" class="d-flex flex-wrap pl-1 pr-1">
        <v-sheet width="100svw" class="d-flex">
            <span style="text-wrap-mode: nowrap"
                >dilmatulgi<template v-if="isStandalone">
                    <v-icon
                        icon="mdi-check"
                        color="success"
                    />standalone </template
                ><template v-else
                    >, api
                    <span v-if="socketConnected"
                        ><v-icon
                            icon="mdi-check"
                            color="success"
                        />connected</span
                    >
                    <span v-else
                        ><v-icon
                            icon="mdi-close"
                            color="error"
                        />disconnected</span
                    >
                </template></span
            >
            <span> </span>
            <v-divider />
            <v-tooltip>
                <template v-slot:activator="{ props }">
                    <v-btn
                        @click="loadFromFile"
                        v-bind="props"
                        :loading="isLoading"
                        :disabled="isFileLoading"
                        color="primary"
                        size="small"
                        prepend-icon="mdi-upload"
                        class="ml-1"
                        >Load</v-btn
                    >
                </template>
                從檔案載入資料
            </v-tooltip>
            <template v-if="!isStandalone">
                <v-btn
                    @click="download"
                    :loading="isLoading"
                    color="primary"
                    size="small"
                    prepend-icon="mdi-download"
                    class="ml-1"
                    >Download</v-btn
                >
                <v-tooltip>
                    <template v-slot:activator="{ props }">
                        <v-btn
                            @click="loadFromServer"
                            v-bind="props"
                            :loading="isLoading"
                            color="primary"
                            size="small"
                            prepend-icon="mdi-refresh"
                            class="ml-1"
                            >Reload</v-btn
                        >
                    </template>
                    從伺服器重新載入資料
                </v-tooltip>
            </template>
            <v-tooltip>
                <template v-slot:activator="{ props }">
                    <v-btn
                        @click="exportOpen = true"
                        v-bind="props"
                        :loading="isLoading"
                        color="secondary"
                        size="small"
                        prepend-icon="mdi-export"
                        class="ml-1"
                        >Export</v-btn
                    >
                </template>
                匯出指定場次的 ndjson 資料
            </v-tooltip>
            <v-btn
                @click="clearData"
                :loading="isLoading"
                color="primary"
                size="small"
                prepend-icon="mdi-close"
                class="ml-1"
                >Clear</v-btn
            >
            <UserGuide />
            <v-tooltip>
                <template v-slot:activator="{ props }">
                    <v-btn
                        @click="forceRefresh"
                        v-bind="props"
                        color="secondary"
                        size="small"
                        prepend-icon="mdi-refresh-circle"
                        class="ml-1"
                        >Force Refresh</v-btn
                    >
                </template>
                強制更新所有 UI
            </v-tooltip>
            <v-tooltip>
                <template v-slot:activator="{ props }">
                    <v-btn
                        @click="configOpen = true"
                        v-bind="props"
                        size="small"
                        prepend-icon="mdi-cog"
                        class="ml-1 mr-4"
                        >設定</v-btn
                    >
                </template>
                開啟設定
            </v-tooltip></v-sheet
        >
    </v-sheet>

    <v-sheet
        v-if="isFileLoading"
        class="d-flex align-center pa-2"
        style="gap: 8px"
    >
        <v-icon icon="mdi-file-import-outline" size="small" />
        <span style="font-size: 0.85em; white-space: nowrap"
            >Loading {{ fileLoadMessage }}</span
        >
        <v-progress-linear
            :model-value="fileLoadProgress"
            color="primary"
            height="8"
            rounded
            style="flex: 1"
        />
        <span style="font-size: 0.85em; white-space: nowrap"
            >{{ fileLoadProgress }}%</span
        >
    </v-sheet>

    <v-sheet
        v-if="hasTimeRange"
        class="d-flex align-center pa-2"
        style="gap: 8px; background: rgba(255, 165, 0, 0.15)"
    >
        <v-icon icon="mdi-clock-outline" color="warning" size="small" />
        <span style="font-size: 0.85em"
            >Time filter: {{ formatTime(timeRangeMin) }} ~
            {{ formatTime(timeRangeMax) }}</span
        >
        <v-spacer />
        <v-btn
            @click="clearTimeRangeFilter"
            color="warning"
            size="x-small"
            prepend-icon="mdi-close"
            variant="text"
            >Clear</v-btn
        >
    </v-sheet>

    <v-tabs v-model="tab">
        <v-tab value="takeDamage">Take Damage</v-tab>
        <v-tab value="applyDamageByEntity">Apply Damage (By Entity)</v-tab>
        <v-tab value="applyDamageBySkill">Apply Damage (By Skill)</v-tab>
        <v-tab value="battleLog">戰鬥記錄</v-tab>
        <v-tab value="summary">Summary</v-tab>
        <v-tab value="playerComparison">玩家比較</v-tab>
        <v-tab value="entityList">Characters</v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
        <v-tabs-window-item value="takeDamage">
            <take-damage />
        </v-tabs-window-item>

        <v-tabs-window-item value="applyDamageByEntity">
            <apply-damage-by-entity />
        </v-tabs-window-item>

        <v-tabs-window-item value="applyDamageBySkill">
            <apply-damage-by-skill />
        </v-tabs-window-item>

        <v-tabs-window-item value="battleLog">
            <battle-log />
        </v-tabs-window-item>

        <v-tabs-window-item value="summary">
            <Summary />
        </v-tabs-window-item>

        <v-tabs-window-item value="playerComparison">
            <PlayerComparison />
        </v-tabs-window-item>

        <v-tabs-window-item value="entityList">
            <entity-list />
        </v-tabs-window-item>
    </v-tabs-window>

    <config-dialog v-model="configOpen" />
    <export-dialog v-model="exportOpen" :raw-ndjson="rawNdjson" />

    <v-dialog v-model="msgBoxOpen" max-width="500" persistent>
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon icon="mdi-alert-circle" color="warning" class="mr-2" />
                MessageBox
            </v-card-title>
            <v-card-text style="white-space: pre-wrap">{{
                msgBoxText
            }}</v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="primary"
                    variant="flat"
                    @click="msgBoxOpen = false"
                    >확인</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>

    <floating-window
        v-for="d in dialogStack.dialogs"
        :key="d.id"
        :title="d.title.value"
        @close="dialogStack.close(d.id)"
    >
        <component :is="d.component" v-bind="d.props" />
    </floating-window>

    <!-- 浮動捲動按鈕 -->
    <div class="scroll-fab-group">
        <v-btn
            v-show="showScrollTop"
            icon="mdi-chevron-up"
            size="small"
            variant="tonal"
            @click="scrollToTop"
        />
        <v-btn
            v-show="showScrollEnd"
            icon="mdi-chevron-down"
            size="small"
            variant="tonal"
            @click="scrollToEnd"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, inject, ref, watch, type Ref } from "vue";

import { useDialogStack } from "@/lib/useDialogStack";
import { SocketClient } from "@/lib/socketClient";
import { eventBase, eventIdMessageBox, eventMessageBox } from "./protocols";
import { clearTimeRange, rawNdjson } from "@/store";
import { sharedSelectedTargetKey } from "@/summaryConfig";
import { RACE_OVERRIDES } from "@/data/raceOverrides";
import { EFFECT_STATE_BUFFS } from "@/effectState";
import { hydrateFromSnapshot } from "@/worker/hydrateActorManager";
import type { WorkerOutMessage } from "@/worker/workerProtocol";

import TakeDamageComponent from "@/components/takeDamage.vue";
import ApplyDamageByEntityComponent from "@/components/applyDamageByEntity.vue";
import ApplyDamageBySkillComponent from "@/components/applyDamageBySkill.vue";
import EntityListComponent from "./components/entityList.vue";
import ConfigDialogComponent from "./components/configDialog.vue";
import FloatingWindowComponent from "./components/subComponents/floatingWindow.vue";
import BattleLogComponent from "./components/battleLog.vue";
import SummaryComponent from "./components/summary.vue";
import PlayerComparisonComponent from "./components/playerComparison.vue";
import UserGuideComponent from "./components/UserGuide.vue";
import ExportDialogComponent from "./components/exportDialog.vue";

export default defineComponent({
    name: "App",
    components: {
        TakeDamage: TakeDamageComponent,
        ApplyDamageByEntity: ApplyDamageByEntityComponent,
        ApplyDamageBySkill: ApplyDamageBySkillComponent,
        EntityList: EntityListComponent,
        BattleLog: BattleLogComponent,
        Summary: SummaryComponent,
        PlayerComparison: PlayerComparisonComponent,
        ConfigDialog: ConfigDialogComponent,
        FloatingWindow: FloatingWindowComponent,
        UserGuide: UserGuideComponent,
        ExportDialog: ExportDialogComponent,
    },
    setup() {
        const isLoading = inject("isLoading");
        const region = inject("region");
        const lang = inject("lang") as Ref<string>;
        const regionList = inject("regionList");
        const db = inject("db");
        const raceNameMap      = inject("raceNameMap");
        const skillNameMap     = inject("skillNameMap");
        const condNameMap      = inject("condNameMap");
        const itemNameMap      = inject("itemNameMap");
        const titleNameMap     = inject("titleNameMap")     as Ref<Record<number, string>>;
        const miniatureNameMap = inject("miniatureNameMap") as Ref<Record<number, string>>;
        const optionSetNameMap = inject("optionSetNameMap") as Ref<Record<number, string>>;
        const appEvent = inject("appEvent");
        const actorManager = inject("actorManager");
        const dcManager = inject("dcManager");

        const hasTimeRange = inject("hasTimeRange");
        const timeRangeMin = inject("timeRangeMin");
        const timeRangeMax = inject("timeRangeMax");

        const socketConnected = ref(false);
        const configOpen = ref(false);
        const exportOpen = ref(false);
        const msgBoxOpen = ref(false);
        const msgBoxText = ref("");

        const isStandalone = __IS_STANDALONE__;

        const socket = new SocketClient(`/ws`);
        socket.onConnect = (isConnected) =>
            (socketConnected.value = isConnected);
        socket.onEvent = (events) => {
            for (const event of events) {
                if (event.EventId === eventIdMessageBox) {
                    const e = event as eventMessageBox;
                    msgBoxOpen.value = true;
                    msgBoxText.value += `${e.Message}\n`;

                    return;
                }

                actorManager.value.onEvent(event);
            }
        };

        const fileLoadProgress = ref(0);
        const fileLoadMessage = ref("");
        const isFileLoading = ref(false);

        const loadJsonData = (input: File | string): Promise<void> => {
            return new Promise<void>(async (resolve, reject) => {
                isFileLoading.value = true;
                fileLoadProgress.value = 0;
                fileLoadMessage.value = "解析中...";

                const t0 = performance.now();
                const worker = new Worker(
                    new URL("./worker/eventWorker.ts", import.meta.url),
                    { type: "module" },
                );

                worker.onmessage = (e: MessageEvent<WorkerOutMessage>) => {
                    const msg = e.data;

                    if (msg.type === "progress") {
                        fileLoadProgress.value = msg.pct;
                        fileLoadMessage.value =
                            msg.phase === "parse"
                                ? "解析中..."
                                : "處理事件中...";
                    } else if (msg.type === "done") {
                        fileLoadMessage.value = "載入畫面中...";
                        console.log(
                            `Worker done in ${(performance.now() - t0).toFixed(0)}ms`,
                        );

                        const t1 = performance.now();
                        hydrateFromSnapshot(
                            msg.snapshot,
                            actorManager.value,
                            dcManager.value,
                        );
                        console.log(
                            `hydrate done in ${(performance.now() - t1).toFixed(0)}ms`,
                        );

                        fileLoadProgress.value = 100;
                        isFileLoading.value = false;
                        worker.terminate();
                        resolve();
                    } else if (msg.type === "error") {
                        console.error("Worker error:", msg.message);
                        isFileLoading.value = false;
                        worker.terminate();
                        reject(new Error(msg.message));
                    }
                };

                worker.onerror = (err) => {
                    console.error("Worker uncaught error", err);
                    isFileLoading.value = false;
                    worker.terminate();
                    reject(err);
                };

                const buffer = input instanceof File
                    ? await input.arrayBuffer()
                    : new TextEncoder().encode(input).buffer;
                worker.postMessage({ type: "process", buffer }, [buffer as ArrayBuffer]);
            });
        };

        const forceRefresh = () => {
            actorManager.value.forceUpdateAll();
        };

        const clearData = () => {
            appEvent.value.dispatchEvent(new CustomEvent("clear"));

            actorManager.value.clear();
            dcManager.value.clear();
            clearTimeRange();
            rawNdjson.value = "";
            sharedSelectedTargetKey.value = '';
        };

        const clearTimeRangeFilter = () => clearTimeRange();

        const formatTime = (v: any) => {
            if (v == null) return "";
            return new Date(v).toLocaleTimeString();
        };

        const download = () => {
            window.open("/api/packet_log", "_blank");
        };

        const loadFromFile = async () => {
            const input = document.createElement("input");

            try {
                input.type = "file";
                input.accept = ".ndjson";
                input.click();

                await new Promise<void>((resolve) => {
                    input.addEventListener("cancel", () => {
                        console.log("file select cancel");
                        resolve();
                    });
                    input.addEventListener("change", () => {
                        console.log("file selected");
                        resolve();
                    });
                });

                if (!input.files?.length) {
                    // ?
                    return;
                }

                const file = input.files[0];

                clearData();
                await loadJsonData(file);
                rawNdjson.value = await file.text();
            } finally {
                input.remove();
            }
        };

        const loadFromServer = async () => {
            const prevHandler = socket.onEvent;
            const temporaryStore = [] as eventBase[];

            try {
                const res = await fetch("/api/packet_log");
                if (!res.ok) {
                    throw new Error(`failed to fetch data ${res.status}`);
                }

                socket.onEvent = (e) => temporaryStore.push(...e);
                const jsonData = await res.text();

                clearData();
                await loadJsonData(jsonData);
                rawNdjson.value = jsonData;
            } catch (e) {
                console.error(e);
                alert(`failed to load data ${e}`);
            } finally {
                socket.onEvent = prevHandler;

                for (const e of temporaryStore) {
                    actorManager.value.onEvent(e);
                }
                temporaryStore.length = 0;
            }
        };

        const dialogStack = useDialogStack();
        const tab = ref("");

        const reloadNameMaps = async () => {
            const currentLang = lang.value;

            if (isStandalone) {
                // standalone 模式：直接使用 build 時打包的本地靜態資料，
                // 不依賴 mabires.pril.cc（該 CDN 不對外開放 CORS）
                const safeLang = ['tw', 'cn', 'jp', 'kr', 'us'].includes(currentLang) ? currentLang : 'tw';
                const [skillMod, raceMod, condMod, itemMod, titleMod, miniMod, optMod] = await Promise.all([
                    import(`@/data/generated/skill_${safeLang}.ts`),
                    import(`@/data/generated/race_${safeLang}.ts`),
                    import(`@/data/generated/cond_${safeLang}.ts`),
                    import(`@/data/generated/item_${safeLang}.ts`),
                    import(`@/data/generated/title_${safeLang}.ts`),
                    import(`@/data/generated/miniature_${safeLang}.ts`),
                    import(`@/data/generated/optionset_${safeLang}.ts`),
                ]);
                skillNameMap.value     = { ...(skillMod as any).skills };
                raceNameMap.value      = { ...(raceMod as any).races };
                condNameMap.value      = { ...(condMod as any).conditions };
                itemNameMap.value      = { ...(itemMod as any).items };
                titleNameMap.value     = { ...(titleMod as any).titles };
                miniatureNameMap.value = { ...(miniMod as any).miniatures };
                optionSetNameMap.value = { ...(optMod as any).optionSets };

                EFFECT_STATE_BUFFS.forEach((d) => {
                    condNameMap.value[d.ccId] = skillNameMap.value[d.iconSkillId] ?? d.name;
                });
                const overrides = RACE_OVERRIDES[currentLang] ?? {};
                for (const [id, name] of Object.entries(overrides)) {
                    raceNameMap.value[Number(id)] = name;
                }
                console.log("資料對照表載入完成（本地）", currentLang);
                return;
            }

            const [races, skills, conds, items, titles, miniatures, optionSets] = await Promise.all([
                db.value.getSortedListData("RaceList"),
                db.value.getSortedListData("SkillList"),
                db.value.getSortedListData("CharCondList"),
                db.value.getSortedListData("ItemList"),
                db.value.getSortedListData("TitleList"),
                db.value.getSortedListData("MiniatureList"),
                db.value.getSortedListData("OptionSetList"),
            ]);

            races.forEach((v) => {
                const resolved = db.value.getCurLangString(v.Name);
                if (resolved === v.Name || resolved.includes("not found key")) {
                    // 全伺服器都沒有本地化名稱時（如 race 7615），
                    // 用 ClassName 格式化作為跨語言 fallback，
                    // 比保留 race.ts 的 TW 中文更適合非中文語系
                    if (v.ClassName) {
                        raceNameMap.value[v.Id] = `${v.ClassName.replace(/_/g, ' ')} ${v.Id}`;
                    }
                    return;
                }
                raceNameMap.value[v.Id] = `${resolved} ${v.Id}`;
            });
            skills.forEach((v)    => (skillNameMap.value[v.Id]     = db.value.getCurLangString(v.Name)));
            items.forEach((v)     => (itemNameMap.value[v.Id]      = db.value.getCurLangString(v.Name)));
            conds.forEach((v)     => (condNameMap.value[v.Id]      = db.value.getCurLangString(v.Name)));
            titles.forEach((v)    => (titleNameMap.value[v.Id]     = db.value.getCurLangString(v.Name)));
            miniatures.forEach((v)=> (miniatureNameMap.value[v.Id] = db.value.getCurLangString(v.Name)));
            optionSets.forEach((v)=> (optionSetNameMap.value[v.Id] = db.value.getCurLangString(v.Name)));

            // effect-state 合成 buff：DB 沒有這些鍵，需在 skillNameMap 更新後手動填入
            EFFECT_STATE_BUFFS.forEach((d) => {
                condNameMap.value[d.ccId] = skillNameMap.value[d.iconSkillId] ?? d.name;
            });

            // 手動覆蓋：DB 缺少本地化名稱的 race（如 7615），以語言別正確名稱套用
            const overrides = RACE_OVERRIDES[currentLang] ?? {};
            for (const [id, name] of Object.entries(overrides)) {
                raceNameMap.value[Number(id)] = name;
            }

            console.log("資料對照表載入完成", currentLang);
        };

        watch(lang, async () => {
            try {
                await db.value.tryOpen();
                await reloadNameMaps();
            } catch (e) {
                console.error("語言切換失敗", e);
            }
        });

        onMounted(async () => {
            try {
                console.log("開始初始化...");
                regionList.value = ["kr", "krt", "cn", "jp", "tw", "us"];

                await db.value.tryOpen();
                console.log("DB Open Success");

                await reloadNameMaps();

                if (!isStandalone) {
                    socket.connect();
                }
            } catch (e) {
                console.error(e);
                alert(`failed to load data ${e}`);
            }
        });

        // ── 浮動捲動按鈕 ──────────────────────────────────────────
        const showScrollTop = ref(false);
        const showScrollEnd = ref(true);

        function updateScrollFab() {
            const scrollY  = window.scrollY;
            const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
            showScrollTop.value = scrollY > 80;
            showScrollEnd.value = maxScroll > 80 && scrollY < maxScroll - 20;
        }

        window.addEventListener("scroll", updateScrollFab, { passive: true });
        updateScrollFab();

        function scrollToTop() { window.scrollTo({ top: 0, behavior: "smooth" }); }
        function scrollToEnd() { window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" }); }

        return {
            isLoading,
            region,
            isStandalone,

            socketConnected,
            msgBoxOpen,
            msgBoxText,
            forceRefresh,
            clearData,
            download,
            loadFromFile,
            loadFromServer,

            tab,
            dialogStack,

            configOpen,
            exportOpen,
            rawNdjson,

            hasTimeRange,
            timeRangeMin,
            timeRangeMax,
            clearTimeRangeFilter,
            formatTime,

            isFileLoading,
            fileLoadProgress,
            fileLoadMessage,

            showScrollTop,
            showScrollEnd,
            scrollToTop,
            scrollToEnd,
        };
    },
});
</script>

<style scoped>
.scroll-fab-group {
    position: fixed;
    right: 16px;
    bottom: 24px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>
